const PRESERVE_MORPH_ATTRIBUTES = 'data-ui-preserve-attr';

const declareMorphAttributes = (element: Element, ...names: string[]): void => {
    const declared = new Set(
        (element.getAttribute(PRESERVE_MORPH_ATTRIBUTES) ?? '')
            .split(/\s+/)
            .filter(Boolean),
    );
    names.filter(Boolean).forEach((name) => declared.add(name));
    if (declared.size > 0) {
        element.setAttribute(PRESERVE_MORPH_ATTRIBUTES, Array.from(declared).join(' '));
    }
};

const preserveDeclaredMorphAttributes = (from: Node, to: Node): void => {
    if (!(from instanceof Element) || !(to instanceof Element)) return;
    const preserved = new Set([
        ...(from.getAttribute(PRESERVE_MORPH_ATTRIBUTES) ?? '').split(/\s+/),
        ...(to.getAttribute(PRESERVE_MORPH_ATTRIBUTES) ?? '').split(/\s+/),
    ].filter(Boolean));
    if (preserved.size === 0) return;
    to.setAttribute(PRESERVE_MORPH_ATTRIBUTES, Array.from(preserved).join(' '));

    for (const name of preserved) {
        if (from.hasAttribute(name)) {
            to.setAttribute(name, from.getAttribute(name) ?? '');
        } else {
            to.removeAttribute(name);
        }
    }
};

export {
    PRESERVE_MORPH_ATTRIBUTES,
    declareMorphAttributes,
    preserveDeclaredMorphAttributes,
};
